import type { RouteContext } from '@townsquare/router/routing-types';

import Loadable from '@townsquare/loadable';
import { peopleDirectoryRoute } from '@townsquare/routes/people-directory-view';
import { tqlExplainerResource } from '@townsquare/tql/resource';

import { peopleDirectoryResource } from './resources/people-directory';
import { peopleDirectoryTableResource } from './resources/people-directory-table';

const PeopleDirectoryLoadable = Loadable<RouteContext, any>({
	loader: () => import(/* webpackChunkName: "peopleDirectory-view" */ './components/PeopleDirectory'),
	loading: () => null,
});

peopleDirectoryRoute.component = PeopleDirectoryLoadable;
peopleDirectoryRoute.resources = [peopleDirectoryResource, tqlExplainerResource, peopleDirectoryTableResource];
export const peopleDirectoryRouterRoute = peopleDirectoryRoute;
